<script lang="ts">
  import { goto } from '$app/navigation';
  import Loading from '$lib/components/Loading.svelte';
  import StudentClassList from '$lib/components/student/StudentClassList.svelte';
  import { auth } from '$lib/stores/auth.svelte';
  import { utcNowIso } from '$lib/util';
  import type { PageProps } from './$types';

  if (auth.user?.redirectClassId !== undefined) {
    // if a student has only one class to load, there's no reason for them to have to look at a list of classes first
    goto(`/classes/${auth.user.redirectClassId}`, { replaceState: true });
  }

  let { data }: PageProps = $props();
  let utcNow = utcNowIso();
</script>

<main id="main-container" class="container py-3">
  {#await data.studentClasses}
    <Loading />
  {:then leaderboards}
    <h2>Current and Upcoming</h2>
    <StudentClassList leaderboards={leaderboards.filter(x => x.class.endDate >= utcNow)} />
    <h2 class="mt-5">Past</h2>
    <StudentClassList leaderboards={leaderboards.filter(x => x.class.endDate < utcNow)} />
  {/await}
</main>
